(ns dashboard.components.inputs
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen]]
   ["@heroicons/react/solid" :refer [SearchIcon]]))

(defn input
  [{:keys [id auto-complete name type value on-change default-value label
           disabled? class step min max]
    :or {on-change identity
         class "mt-1 py-2"}}]
  [:<>
   (when (some? label)
     [:label.block.text-sm.font-medium.text-gray-700
      {:for id}
      label])
   [:input.block.w-full.border.border-gray-300.rounded-md.shadow-sm.px-3.focus:outline-none.focus:ring-primary-500.focus:border-primary-500.sm:text-sm.disabled:bg-slate-50.disabled:text-slate-500.disabled:border-slate-200.disabled:shadow-none.invalid:border-red-500.invalid:text-red-600.focus:invalid:border-red-500.focus:invalid:ring-red-500
    (cond-> {:class class
             :default-value default-value
             :id id
             :step step
             :min min
             :max max
             :auto-complete auto-complete
             :disabled disabled?
             :name name
             :type type
             :on-change (fn [e]
                          (on-change (-> e .-target .-value)))}
      (some? value) (assoc :value value))]])

(defn search-input [{:keys [input-string class label placeholder on-change]}]
  [:div.flex.space-x-4
   {:action "#"}
   [:div.flex-1.min-w-0
    [:label.sr-only
     {:htmlFor "search"}
     (tr :action/search)]
    [:div.relative.rounded-md.shadow-sm
     [:div.absolute.inset-y-0.left-0.pl-3.flex.items-center.pointer-events-none
      [:> SearchIcon
       {:class "h-5 w-5 text-gray-400"
        :aria-hidden true}]]
     [:input.focus:ring-primary-500.focus:border-primary-500.block.w-full.pl-10.sm:text-sm.border-gray-300.rounded-md
      {:type "search"
       :name "search"
       :id "search"
       :autoComplete "off"
       :value @input-string
       :on-change on-change
       :placeholder placeholder}]]]])

(defn textarea
  [{:keys [id auto-complete name type on-change default-value label disabled? rows]
    :or {on-change identity
         rows 4}}]
  [:<>
   (when (some? label)
     [:label.block.text-sm.font-medium.text-gray-700
      {:for id}
      label])
   [:textarea.shadow-sm.focus:ring-primary-500.focus:border-primary-500.block.w-full.sm:text-sm.border-gray-300.rounded-md
    {:default-value default-value
     :id id
     :auto-complete auto-complete
     :disabled disabled?
     :name name
     :type type
     :rows rows
     :on-change (fn [e]
                  (on-change (-> e .-target .-value)))}]])
